import { render, staticRenderFns } from "./Indice.vue?vue&type=template&id=97200c6e&"
import script from "./Indice.vue?vue&type=script&lang=ts&"
export * from "./Indice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports